import { memo, useState, useEffect, useCallback, useRef } from 'react';
import { Modal, Text, Spacer, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import WarningGif from 'components/WarningGif';
import './styles.scss';

const AutomationBuilderWarningModal = memo(({ onRef, name }) => {
    const theme = useTheme();
    const saveCb = useRef(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        onRef &&
            onRef({
                open(_, onSaveCb) {
                    if (onSaveCb) saveCb.current = onSaveCb;
                    setOpen(true);
                },
            });
    }, [onRef]);

    const onInnerCancel = useCallback(() => {
        setOpen(false);
    }, []);

    const onInnerSave = useCallback(() => {
        setOpen(false);
        saveCb?.current?.();
    }, []);

    const onCancel = useCallback(() => {
        setOpen(false);
        saveCb?.current?.({ enabled: false });
    }, []);

    return (
        <Modal
            overlayClassName="fm-automation-builder__warning-modal"
            isOpen={open}
            onRequestClose={onInnerCancel}
            onCancel={onCancel}
            onConfirm={onInnerSave}
            confirmText={getLiteral('action_automation_launch_now')}
            cancelText={getLiteral('action_automation_save_inactive')}
            title={getLiteral('label_automation_save_confirmation')}
        >
            <div className="fm-automation-builder__warning-modal__gif">
                <WarningGif />
            </div>
            <Spacer y={3} />
            <Text color={theme.colors.textLight.secondary}>
                {getLiteral('label_automation_save_confirmation_desc')}
            </Text>
            <Spacer y={3} />
            <Text bold className="fm-automation-builder__warning-modal__name">
                {name}
            </Text>
            <Spacer y={2} />
        </Modal>
    );
});

export default AutomationBuilderWarningModal;
